import { API_PREFIX } from '@/config/api'
import api from '@/helpers/api'

const getStatistics = (params: any) =>
    api.get(`${API_PREFIX}/statistics`, { params }).then(response => Promise.resolve(response.data))

export const statisticService = {
    getStatistics
}
